import axios from '@!/lib/axios'
import { buildUrlString } from '@!/Util'

export const getTopBulkPurchaseTitlesApi = async (safeSearch) => {
  const params = { safe_search: safeSearch }
  const url = buildUrlString('/api/v1/bulk_purchase_titles/top', params)
  return await axios.get(url)
}
